export const fr = {
  // Navigation
  nav: {
    home: 'Accueil',
    search: 'Recherche',
    inspirations: 'Inspirations',
    about: 'À propos',
    favorites: 'Favoris',
    login: 'Connexion',
    advisor: 'Conseiller',
    speakToAdvisor: 'Parler à un Conseiller'
  },

  // Homepage
  homepage: {
    heroTitle: 'PRIVIA',
    heroSubtitle: 'L\'incarnation visuelle des émotions les plus raffinées',
    heroDescription: 'Nous ne montrons pas des villas, nous faisons ressentir un art de vivre',
    heroExperiences: 'Expériences Exclusives',
    discoverVillas: 'Découvrir nos Villas',
    speakToConcierge: 'Parler à notre Concierge',
    
    // Destinations section
    destinationsTitle: 'Nos Destinations d\'Exception',
    destinationsSubtitle: 'Des lieux d\'exception soigneusement sélectionnés où le luxe rencontre l\'authenticité, pour des expériences inoubliables aux quatre coins du monde.',
    destinationsStats: 'destinations • 200+ villas d\'exception',
    allRegions: 'Toutes les Régions',
    
    // Villa search section
    findEmotion: 'Trouvez Votre Émotion',
    findEmotionSubtitle: 'Chaque villa raconte une histoire, évoque une émotion unique. Laissez-vous guider par vos ressentis.',
    searchPlaceholder: 'Rechercher par destination, émotion...',
    
    // Villas section
    villasTitle: 'Nos Villas d\'Exception',
    villasSubtitle: 'Chaque propriété est sélectionnée pour sa capacité à éveiller des émotions profondes et créer des souvenirs inoubliables.',
    villasForEmotion: 'villa(s) pour votre émotion',
    noVillasFound: 'Aucune villa trouvée pour cette recherche',
    resetFilters: 'Réinitialiser les filtres',
    
    // Social proof
    excellenceTitle: 'L\'Excellence Reconnue',
    prestigePartners: 'Partenaires de Prestige',
    
    // Stats
    stats: {
      villas: 'Villas d\'Exception',
      destinations: 'Destinations',
      satisfaction: 'Satisfaction Client',
      service: 'Service Concierge'
    },
    
    // Footer
    footer: {
      tagline: 'L\'art de vivre à son apogée',
      copyright: '© 2024 PRIVIA. Tous droits réservés.',
      legal: 'Mentions légales',
      gdpr: 'RGPD',
      madeWith: 'Conçu avec',
      in: 'à Paris'
    }
  },

  // Emotions
  emotions: {
    serenity: {
      label: 'Sérénité Pure',
      description: 'Respiration qui se ralentit, épaules qui se détendent'
    },
    privilege: {
      label: 'Privilège Discret',
      description: 'Sentiment d\'appartenir à un cercle secret'
    },
    anticipation: {
      label: 'Anticipation Magique',
      description: 'Frisson d\'excitation, cœur qui s\'accélère délicatement'
    },
    intimacy: {
      label: 'Intimité Sophistiquée',
      description: 'Chaleur enveloppante, cocon luxueux'
    },
    freedom: {
      label: 'Liberté Infinie',
      description: 'Souffle coupé devant l\'horizon'
    },
    allEmotions: 'Toutes les Émotions'
  },

  // Villa details
  villa: {
    backToVillas: 'Retour aux villas',
    bookNow: 'Réserver Maintenant',
    checkAvailability: 'Vérifier Disponibilité',
    story: 'L\'Histoire de cette Villa',
    pricingSeasons: 'Tarifs par Saison',
    signatureExperiences: 'Expériences Signature',
    exceptionalAmenities: 'Équipements d\'Exception',
    includedServices: 'Services Inclus',
    location: 'Localisation',
    characteristics: 'Caractéristiques',
    livingSpace: 'Surface habitable',
    grounds: 'Terrain',
    capacity: 'Capacité',
    bedrooms: 'Chambres',
    bathrooms: 'Salles de bain',
    coordinates: 'Coordonnées',
    pointsOfInterest: 'Points d\'intérêt',
    bookVilla: 'Réserver {villaName}',
    pricingPeriod: 'Période tarifaire',
    arrival: 'Arrivée',
    departure: 'Départ',
    guests: 'Nombre d\'invités',
    person: 'personne',
    people: 'personnes',
    nights: 'nuits',
    includedServices: 'Services inclus',
    included: 'Inclus',
    total: 'Total',
    confirmBooking: 'Confirmer la Réservation',
    gallery: 'Galerie',
    callNow: 'Appeler maintenant',
    privateMessage: 'Message privé'
  },

  // Search page
  search: {
    destination: 'Destination',
    allDestinations: 'Toutes destinations',
    arrival: 'Arrivée',
    departure: 'Départ',
    travelers: 'Voyageurs',
    filters: 'Filtres',
    budget: 'Budget (€/semaine)',
    min: 'Min',
    max: 'Max',
    minBedrooms: 'Chambres min.',
    indifferent: 'Indifférent',
    bedroom: 'chambre',
    bedrooms: 'chambres',
    clearFilters: 'Effacer les filtres',
    filterByEmotion: 'Filtrer par émotion',
    villasIn: 'Villas à {destination}',
    villaSearch: 'Recherche de Villas',
    available: 'disponible(s) pour vos dates',
    relevance: 'Pertinence',
    priceAsc: 'Prix croissant',
    priceDesc: 'Prix décroissant',
    nameAZ: 'Nom A-Z',
    noVillasFound: 'Aucune villa trouvée',
    tryModifying: 'Essayez de modifier vos critères de recherche ou explorez nos destinations populaires',
    resetSearch: 'Réinitialiser la recherche'
  },

  // Inspirations page
  inspirations: {
    title: 'Vous ne savez pas où partir ?',
    subtitle: 'Laissez-vous inspirer par nos collections thématiques et découvrez votre prochaine destination de rêve',
    exploreCollections: 'Explorer les Collections',
    allInspirations: 'Toutes les inspirations',
    seasons: 'Saisons',
    family: 'En famille',
    romantic: 'Romantique',
    adventure: 'Aventure',
    wellness: 'Bien-être',
    collectionsTitle: 'Collections d\'Inspiration',
    collectionsSubtitle: 'Chaque collection raconte une histoire, évoque une émotion et vous guide vers l\'expérience parfaite',
    destinations: 'destinations',
    villas: 'villas',
    exploreCollection: 'Explorer cette collection',
    personalizedTitle: 'Votre Inspiration Personnalisée',
    personalizedSubtitle: 'Nos conseillers créent des expériences sur-mesure selon vos passions et vos rêves',
    speakToAdvisor: 'Parler à un Conseiller'
  },

  // About page
  about: {
    title: 'L\'Art de Vivre Réinventé',
    subtitle: 'Depuis 2014, PRIVIA révolutionne l\'expérience du voyage de luxe en créant des ponts émotionnels entre nos clients et les plus belles demeures du monde',
    ourStory: 'Notre Histoire',
    mission: 'Notre Mission',
    missionTitle: 'Créer des Émotions Authentiques',
    missionText1: 'Chez PRIVIA, nous croyons que chaque voyage doit être une renaissance. Notre mission transcende la simple location de villas : nous créons des expériences qui marquent une vie, des souvenirs qui deviennent des trésors.',
    missionText2: 'Notre approche unique par les émotions nous permet de vous guider vers la villa qui résonnera parfaitement avec vos aspirations les plus profondes, créant une harmonie parfaite entre le lieu et votre état d\'âme.',
    discoverCollection: 'Découvrir notre Collection',
    excellence: 'L\'excellence',
    excellenceDescription: 'Notre signature dans chaque détail de votre expérience',
    foundingValues: 'Nos Valeurs Fondatrices',
    foundingValuesSubtitle: 'Quatre piliers guident chacune de nos actions et façonnent l\'expérience PRIVIA',
    passionForBeauty: 'Passion du Beau',
    passionDescription: 'Nous sélectionnons chaque villa avec le même soin qu\'un collectionneur choisit une œuvre d\'art.',
    serviceExcellence: 'Excellence du Service',
    serviceDescription: 'Notre concierge 24/7 anticipe vos besoins pour transformer chaque séjour en expérience inoubliable.',
    authenticity: 'Authenticité',
    authenticityDescription: 'Chaque destination révèle ses secrets les mieux gardés grâce à notre réseau local privilégié.',
    emotionalInnovation: 'Innovation Émotionnelle',
    innovationDescription: 'Notre approche unique par les émotions vous guide vers la villa qui résonnera avec votre âme.',
    priviaInNumbers: 'PRIVIA en Chiffres',
    numbersSubtitle: 'Une décennie d\'excellence au service de vos rêves d\'évasion',
    team: 'L\'Équipe PRIVIA',
    teamSubtitle: 'Des passionnés au service de vos émotions les plus précieuses',
    readyToExperience: 'Prêt à Vivre l\'Expérience PRIVIA ?',
    advisorsReady: 'Nos conseillers sont à votre écoute pour créer votre voyage sur-mesure',
    planCall: 'Planifier un Appel',
    contactUs: 'Nous Contacter'
  },

  // Common
  common: {
    loading: 'Chargement...',
    error: 'Une erreur s\'est produite',
    close: 'Fermer',
    cancel: 'Annuler',
    confirm: 'Confirmer',
    save: 'Enregistrer',
    edit: 'Modifier',
    delete: 'Supprimer',
    previous: 'Précédent',
    next: 'Suivant',
    viewMore: 'Voir plus',
    viewLess: 'Voir moins',
    explore: 'Explorer',
    discover: 'Découvrir',
    book: 'Réserver',
    contact: 'Contact',
    phone: 'Téléphone',
    email: 'Email',
    address: 'Adresse',
    website: 'Site web',
    socialMedia: 'Réseaux sociaux',
    followUs: 'Suivez-nous',
    newsletter: 'Newsletter',
    subscribe: 'S\'abonner',
    unsubscribe: 'Se désabonner',
    termsAndConditions: 'Conditions générales',
    privacyPolicy: 'Politique de confidentialité',
    cookiePolicy: 'Politique des cookies'
  },

  // Regions
  regions: {
    caribbean: {
      name: 'Caraïbes',
      description: 'Paradis tropical d\'exception'
    },
    frenchRiviera: {
      name: 'Côte d\'Azur',
      description: 'L\'art de vivre à la française'
    },
    corsica: {
      name: 'Corse',
      description: 'L\'île de beauté authentique'
    },
    monaco: {
      name: 'Monaco',
      description: 'Principauté du luxe absolu'
    },
    italy: {
      name: 'Italie',
      description: 'Dolce vita méditerranéenne'
    },
    greece: {
      name: 'Grèce',
      description: 'Mythologie et splendeur égéenne'
    },
    spain: {
      name: 'Espagne',
      description: 'Passion ibérique raffinée'
    }
  }
};